export default "__VITE_ASSET__CfeUndEM__"